import { IUserInfo } from "../../../models/User";

export interface ISidebarProps {
  changeLocation: (url: String) => {};
  showSidebar: (show: boolean) => {};
  show: boolean;
  userInfo: IUserInfo;
  isFromInternet: boolean;
}

export const SHOW_IDENTIFIER: string = "show";
